import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import { FileUploader } from "..";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { VerifyRequestGrid } from "../verify-request-grid/VerifyRequestGrid";
import { verifyUploadAPI } from "../../../api/verifyAPI/verifyUploadAPI";
import { Aside } from "../../components";
import LoadingOverlay from "react-loading-overlay-ts";
import { PopUp } from "../../components/PopUp/PopUp.js";

const type = ["Phone", "Email"];

const VerifyContainer = (props) => {
  const [isActive, setActive] = useState(false);
  const [show, setShow] = useState({ status: false, message: "" });
  const [selectedValue, setSelectedValue] = useState("Phone");
  const [data, setDataGrid] = useState([]);
  const [error, setError] = useState([]);

  const handleChange = useCallback(
    (e) => {
      setSelectedValue(e.value);
    },
    [setSelectedValue]
  );

  const hideModal = () => {
    setShow(false);
  };

  const onFileAdded = async (binaryStr, fileName) => {
    setActive(true);
    const newData = [...data];

    try {
      const res = await verifyUploadAPI.importFile(
        binaryStr,
        "",
        fileName,
        selectedValue
      );
      if (res.status !== 200) {
        setShow({
          status: true,
          message:
            "Si è verificato un errore durante il tentativo di importare il file.",
        });
      } else {
        setError(res.data.errorsMessages.statusMessage);
        if (newData.length === 0) {
          newData.push({
            size: res.data.numberOfRows,
            match_size: res.data.numberOfMatchRows,
            type: res.data.type,
            download_id: res.data.matchingFileId,
          });
        } else {
          let index = newData.indexOf((x) => x.type === res.data.type);
          if (index >= 0) {
            newData[index] = {
              size: res.data.numberOfRows,
              match_size: res.data.numberOfMatchRows,
              type: res.data.type,
              download_id: res.data.matchingFileId,
            };
          } else {
            newData.push({
              size: res.data.numberOfRows,
              match_size: res.data.numberOfMatchRows,
              type: res.data.type,
              download_id: res.data.matchingFileId,
            });
          }
        }
      }
    } catch (error) {
      setShow({
        status: true,
        message:
          "Si è verificato un errore durante il tentativo di importare il file.",
      });
    }
    setActive(false);
    setDataGrid(newData);
  };
  return (
    <>
      <LoadingOverlay active={isActive} spinner text="Loading ...">
        <PopUp show={show.status} handleClose={hideModal}>
          <div
            className="row"
            style={{
              height: "30px",
              marginLeft: "0px",
              marginRight: "0px",
              backgroundColor: "#FDA443",
              borderRadius: "10px 10px 0px 0px",
            }}
          >
            {" "}
          </div>
          <p></p>
          <h2 className="row justify-content-md-center">{show.message}</h2>
        </PopUp>
        <div className="Verify-page">
          <div className="row">
            <div className="Verify-title">Verifica Massiva</div>
          </div>
          <div className="container border border-light">
            <div>
              <div
                className="row justify-content-end"
                style={{ marginBottom: "3.6em", marginRight: "4.6em" }}
              >
                <DropDownList
                  data={type}
                  value={selectedValue}
                  onChange={handleChange}
                  style={{ width: "fit-content" }}
                />
              </div>
              <div className="row justify-content-md-center mb-3">
                <div className="col-lg-11">
                  <FileUploader
                    setDataGrid={setDataGrid}
                    type={selectedValue?.toLowerCase()}
                    onFileAdded={onFileAdded}
                  />
                </div>
              </div>
              <div className="row justify-content-md-center">
                <div
                  className="col-lg-11"
                  style={{ marginTop: "3.2em", marginBottom: "1.6em" }}
                >
                  <VerifyRequestGrid
                    dataGrid={data}
                    setShow={setShow}
                    setActive={setActive}
                    error={error}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </>
  );
};

const mapStateToProps = function(state) {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export const Verify = connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyContainer);
